
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-clipboard-demo-plugin-clipboard-resizing"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.zh.md?type=demo')
};